import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m2 11.24v2.76h2.76l9.24-9.24-2.76-2.76zm9.766-11.007 4 4a.8.8 0 0 1 0 1.132l-10.4 10.4a.8.8 0 0 1 -.566.235h-4a.8.8 0 0 1 -.8-.8v-4a.8.8 0 0 1 .234-.566l10.4-10.4a.8.8 0 0 1 1.132 0z",
		fill: "#2b2b2b"
	})
});
export default SvgEdit;
